import React from 'react';
import { dateRanges, selectableDateRanges } from '../../../Data/DateRanges';
import Section from '../../../Components/Containers/Section';
import { usePreference } from '../../../Data/Preference';
import StatCards from '../../../Components/Formatting/StatCards';
import Money from '../../../Components/Formatting/Money';

const Invoices = ({invoices}) => {
    const [dateRange, setDateRange] = usePreference('report-invoice-date-range', 'lastThreeMonths');

    return <Section title="Invoices"
            subtitle={dateRanges[dateRange] ?? dateRange}
            menu={selectableDateRanges.map(dr => ({
                title: dr.label,
                onClick: () => setDateRange(dr.value),
                icon: dr.value === dateRange ? 'CircleCheck' : 'Circle',
            }))}
        >

        <Inner stats={invoices?.[dateRange] ?? null} />
    </Section>
}

const Inner = ({stats}) => {
    if (!stats) {
        return <p className="my-5 text-muted text-center text-sm">No data for this time period</p>;
    }

    return <StatCards cards={[
        {title: 'Paid', value: <Money pence={stats?.paid?.total ?? 0} hidePence />},
        {title: 'Outstanding', value: <Money pence={stats?.outstanding?.total ?? 0} hidePence />},
    ]} />
}

export default Invoices;
